export type Animal =
    | "Bug" | "Cat" | "Chameleon" | "Chick" | "Cobra" | "Cow" | "Cricket" | "Dino" | "Dog" | "Dolphin"
    | "Eagle" | "Frog" | "Giraffe" | "Gorilla" | "Hippo" | "Hog" | "Kangaroo" | "Kiwi" | "Koala" | "Lion"
    | "Llama" | "Lobster" | "Meerkat" | "Mouse" | "Octopus" | "Owl" | "Penguin" | "Platypus" | "Polar-bear"
    | "Shark" | "Sheep" | "Snail" | "Squid" | "Squirrel" | "Tucan" | "Turtle"

export const validAnimals: Animal[] = [
    "Bug", "Cat", "Chameleon", "Chick", "Cobra", "Cow", "Cricket", "Dino", "Dog", "Dolphin",
    "Eagle", "Frog", "Giraffe", "Gorilla", "Hippo", "Hog", "Kangaroo", "Kiwi", "Koala", "Lion",
    "Llama", "Lobster", "Meerkat", "Mouse", "Octopus", "Owl", "Penguin", "Platypus", "Polar-bear",
    "Shark", "Sheep", "Snail", "Squid", "Squirrel", "Tucan", "Turtle"
];

export type Color = "#FFB3BA" | "#FFDFBA" | "#FFFFBA" | "#BAFFC9" | "#BAE1FF" | "#E6B3FF" |
    "#FFCCE5" | "#D4A5A5" | "#FEC8D8" | "#E0BBE4" | "#957DAD" | "#D291BC" |
    "#FEC8C1" | "#FFDAC1" | "#FAF4B7" | "#C1E1C1" | "#B5EAD7" | "#C7CEEA" |
    "#D4E157" | "#A8E6CF" | "#FF8B94" | "#FFC3A0" | "#D4A88C" | "#FFABAB" |
    "#C2DFFF" | "#AFCBFF" | "#D0E1F9" | "#B0E57C" | "#E6F69D" | "#E0F2F1" |
    "#F9D5E5" | "#ACE7FF" | "#D7BDE2" | "#FAD2E1" | "#F7D1CD" | "#FFE6E6";

export const validColors: Color[] = [
    "#FFB3BA", "#FFDFBA", "#FFFFBA", "#BAFFC9", "#BAE1FF", "#E6B3FF",
    "#FFCCE5", "#D4A5A5", "#FEC8D8", "#E0BBE4", "#957DAD", "#D291BC",
    "#FEC8C1", "#FFDAC1", "#FAF4B7", "#C1E1C1", "#B5EAD7", "#C7CEEA",
    "#D4E157", "#A8E6CF", "#FF8B94", "#FFC3A0", "#D4A88C", "#FFABAB",
    "#C2DFFF", "#AFCBFF", "#D0E1F9", "#B0E57C", "#E6F69D", "#E0F2F1",
    "#F9D5E5", "#ACE7FF", "#D7BDE2", "#FAD2E1", "#F7D1CD", "#FFE6E6"
];

const charactersToAdjective: Record<string, string[]> = {
    "B": [
        "Bad", "Bold", "Bouncy", "Brave", "Bright", "Beautiful", "Bold", "Bitter", "Bizarre", "Big",
        "Bouncy", "Boisterous", "Brilliant", "Blissful", "Blazing", "Bright-eyed", "Blunt", "Blowy", "Burnished",
        "Brittle", "Bounteous", "Beautifully", "Beaming", "Bewildered", "Blushing", "Brisk", "Blessed", "Buoyant",
        "Booming", "Brassy", "Brutal", "Breezy", "Bilingual", "Bent", "Bouncy", "Bulging"
    ],
    "C": [
        "Cuddly", "Curious", "Cunning", "Cute", "Calm", "Creepy", "Clumsy", "Cheerful", "Crafty", "Cool",
        "Courageous", "Careful", "Colossal", "Courageous", "Cheeky", "Charming", "Clever", "Calculated", "Chatty",
        "Clean", "Crisp", "Clattering", "Conscientious", "Climbing", "Countryside", "Chilly", "Crushing", "Classy",
        "Crested", "Courageous", "Clutching", "Colorful", "Cool-headed", "Charitable", "Cute", "Council"
    ],
    "D": [
        "Dirty", "Diving", "Dogged", "Delightful", "Devious", "Determined", "Delicate", "Dynamic", "Daring", "Dramatic",
        "Dizzy", "Deadly", "Distracted", "Dashing", "Devoted", "Delightful", "Dominant", "Dapper", "Dainty",
        "Down-to-earth", "Damp", "Dotted", "Delirious", "Decent", "Delight", "Daring", "Driven", "Diligent",
        "Dreamy", "Defiant", "Distrusting", "Dirty-minded", "Disciplined", "Directed", "Dazzling", "Dormant"
    ],
    "E": [
        "Excitable", "Eager", "Elusive", "Enlightened", "Euphoric", "Earnest", "Empathetic", "Engaging", "Envious", "Elevated",
        "Endearing", "Energetic", "Eccentric", "Earthy", "Emotional", "Equanimous", "Expansive", "Elevated", "Enthusiastic",
        "Exuberant", "Epic", "Emboldened", "Elevated", "Efficient", "Exotic", "Encompassing", "Enviable", "Exuberant",
        "Electric", "Enchanting", "Enlivened", "Enticing", "Expedited", "Eager-beaver", "Exalted", "Elated"
    ],
    "F": [
        "Foolish", "Fearless", "Funny", "Fancy", "Fast", "Fluffy", "Frenzied", "Fateful", "Frantic", "Fancy-free",
        "Fateful", "Fantastic", "Frozen", "Fuzzy", "Faithful", "Fierce", "Fancy", "Focused", "Flexible",
        "Free", "Fearsome", "Feisty", "Fiery", "Fun-loving", "Fond", "Fortunate", "Fabulous", "Flamboyant",
        "Flimsy", "Ferocious", "Friendly", "Fond-hearted", "Fantastic", "Famed", "Fearsome", "Fresh"
    ],
    "G": [
        "Graceful", "Giddy", "Goofy", "Generous", "Gutsy", "Grand", "Giggly", "Glorious", "Glistening", "Gallant",
        "Gentle", "Grouchy", "Greedy", "Grateful", "Gleaming", "Garrulous", "Glamorous", "Genuine", "Gritty",
        "Glittering", "Grizzled", "Great", "Grim", "Gassy", "Genuine", "Gorgeous", "Green", "Gutsy",
        "Glaring", "Goofy", "Glistening", "Grouchy", "Gracious", "Glossy", "Glistening", "Galloping"
    ],
    "H": [
        "Hasty", "Happy", "Hardy", "Handsome", "Hopeful", "Hungry", "Hearty", "Horrible", "Hardworking", "Humble",
        "Hilarious", "Hot", "Holy", "Humorous", "Hallowed", "Headstrong", "Healthy", "Honest", "Horrifying",
        "Haunting", "Honorable", "Hectic", "Helpless", "Hungry", "Helpful", "Hasty", "Hearty", "Harmonious",
        "Heated", "High-spirited", "Hazardous", "Horrid", "High-flying", "Humorous", "Heartwarming", "Humble"
    ],
    "L": [
        "Lively", "Lush", "Luminous", "Loyal", "Lavish", "Lucid", "Lanky", "Lyrical", "Lustrous", "Lamentable",
        "Lofty", "Lingering", "Luscious", "Laconic", "Lethargic", "Ludicrous", "Lachrymose", "Lugubrious", "Limpid",
        "Lissome", "Lackadaisical", "Laudable", "Lacerated", "Languid", "Lamenting", "Leisurely", "Loquacious", "Lopsided",
        "Lustful", "Lachrymatory", "Lugubrious", "Limber", "Lame", "Luxurious", "Loyalist", "Labile"
    ],
    "K": [
        "Keen", "Kind", "Kooky", "Knotty", "Kryptic", "Knockout", "Kissing",
        "Killer", "Key", "Kick-start", "Keynote", "Knowing", "Kaleidoscopic",
        "Knotted", "Kooky", "Kinetic", "Kickin", "Karmic", "Knit",
        "Keen-eyed", "Kempt", "Killer", "Kooky", "Knack", "Kicked-back",
        "Keen-minded", "Knightly", "Key", "Kinematic", "Karma", "Kingly",
        "Kaleidoscope", "Kempt", "Kind-hearted", "Kangaroo", "Knot"
    ],
    "M": [
        "Mischievous", "Marvelous", "Magical", "Muscular", "Mighty",
        "Mysterious", "Merciful", "Majestic", "Modest", "Mad",
        "Mystical", "Mobile", "Methodical", "Magnificent", "Manic",
        "Musical", "Muddy", "Mutable", "Monumental", "Magnanimous",
        "Meddlesome", "Motivated", "Moody", "Manageable", "Mellow",
        "Meticulous", "Modest", "Memorable", "Menacing", "Massive",
        "Mindful", "Meaningful", "Monotonous", "Merry", "Majestic",
        "Muscular"
    ],
    "O": [
        "Outrageous", "Obedient", "Odd", "Observant", "Organic",
        "Optimistic", "Ostentatious", "Overpowering", "Open", "Obscure",
        "Oddball", "Original", "Overwhelming", "Ornate", "Outstanding",
        "Offensive", "Ordinary", "Omniscient", "Outrageous", "Observant",
        "Observant", "Obsessive", "Opulent", "Open-minded", "Overt",
        "Open-hearted", "Observant", "Overbearing", "Obedient", "Outgoing",
        "Optimistic", "Obnoxious", "Obscure", "Outgoing", "Optimistic",
        "Outgoing"
    ],
    "P": [
        "Playful", "Powerful", "Persistent", "Patient", "Pretty",
        "Practical", "Positive", "Precocious", "Proud", "Precise",
        "Profound", "Protective", "Philosophical", "Perplexing", "Pleasant",
        "Prominent", "Progressive", "Peculiar", "Picky", "Polite",
        "Pensive", "Profound", "Productive", "Peaceful", "Passionate",
        "Poetic", "Perceptive", "Pugnacious", "Prestigious", "Perfect",
        "Pompous", "Palpitating", "Playful", "Primal", "Prophetic",
        "Precious"
    ],
    "S": [
        "Sneaky", "Strong", "Speedy", "Silent", "Silly",
        "Scary", "Spectacular", "Sweet", "Stubborn", "Soft",
        "Sensitive", "Serious", "Sneaky", "Serene", "Shifty",
        "Snappy", "Sociable", "Spirited", "Scrappy", "Submissive",
        "Sophisticated", "Super", "Subtle", "Spectacular", "Sassy",
        "Spooky", "Savage", "Swift", "Sultry", "Stealthy",
        "Successful", "Suspicious", "Sweet-tempered", "Shrewd",
        "Super", "Savory"
    ],
    "T": [
        "Tricky", "Thoughtful", "Tough", "Tenacious", "Trustworthy",
        "Talented", "Terrible", "Turbulent", "Terrifying", "Tidy",
        "Tender", "Triumphant", "Terrifying", "Thoughtful", "Tumultuous",
        "Tactical", "Temperamental", "Tasteful", "Tempting", "Taciturn",
        "Tremendous", "Tenacious", "Tranquil", "Terrible", "Traditional",
        "Tantalizing", "Trusting", "Tidy", "Teeming", "Tall",
        "Timely", "Tremendous", "Theoretical", "Transcendental", "Tactical",
        "Tall"
    ]
};

export function randomColor(): Color {
    return validColors[Math.floor(Math.random() * validColors.length)];
}

export function randomAnimal(): Animal {
    return validAnimals[Math.floor(Math.random() * validAnimals.length)];
}

export function randomAdjective(animalName: Animal): string {
    const adjectives = charactersToAdjective[animalName[0]];
    if (!adjectives) return 'Unknown';
    return adjectives[Math.floor(Math.random() * 36)] ?? 'Unknown';
}

